<template>
  <div>
    <Subscription />
    <div
      :class="[
        'footer footer--color',
        isMobileLayout ? 'footer--mobile' : '',
        isRestaurant && 'is-restaurant',
        isRestaurantDetail && 'is-restaurant',
      ]"
    >
      <MainLayout class="container">
        <mq-layout :mq="['xs', 'sm', 'md']">
          <div class="footer__mobile-shell">
            <div class="footer__brand">
              <el-image
                class="footer__logo"
                :src="images.logo.src"
                :fit="'contain'"
              />
              <div class="subtitle2 footer__address">
                <div>
                  <div>{{ addressLine1 }}</div>
                  <div>{{ addressLine2 }}</div>
                  <div>{{ addressLine3 }}</div>
                </div>
              </div>
              <div class="footer__social-row">
                <a :href="socialLinks.instagram" target="_blank" rel="noopener">
                  <el-image
                    class="footer__social-icon"
                    :src="images.instagramIcon.src"
                    :fit="'contain'"
                  />
                </a>
                <a :href="socialLinks.facebook" target="_blank" rel="noopener">
                  <el-image
                    class="footer__social-icon"
                    :src="images.facebookIcon.src"
                    :fit="'contain'"
                  />
                </a>
              </div>
            </div>

            <div class="footer__mobile-columns">
              <div
                v-for="(menuGroup, index) in menuGroups"
                :key="`mobile-${index}`"
                class="footer__column"
              >
                <h5 class="menu--header">{{ menuGroup.menuHeader }}</h5>
                <FooterMenuItem
                  v-for="(menuItem, itemIndex) in menuGroup.menuItems"
                  :key="`mobile-${index}-${itemIndex}`"
                  :item="menuItem"
                  @select="handleMenuItemClick"
                />
              </div>
            </div>

            <el-divider class="footer__divider" />
            <div class="subtitle2 content-license text-left">
              {{ year }} {{ allRightsReserved }}
            </div>
          </div>
        </mq-layout>

        <mq-layout mq="lg+">
          <div class="footer__desktop-shell">
            <div class="footer__brand footer__brand--desktop">
              <el-image
                class="footer__logo"
                :src="images.logo.src"
                :fit="'contain'"
              />
              <div class="subtitle2 footer__address">
                <div>
                  <div>{{ addressLine1 }}</div>
                  <div>{{ addressLine2 }}</div>
                  <div>{{ addressLine3 }}</div>
                </div>
              </div>
              <div class="footer__social-row">
                <a :href="socialLinks.instagram" target="_blank" rel="noopener">
                  <el-image
                    class="footer__social-icon"
                    :src="images.instagramIcon.src"
                    :fit="'contain'"
                  />
                </a>
                <a :href="socialLinks.facebook" target="_blank" rel="noopener">
                  <el-image
                    class="footer__social-icon"
                    :src="images.facebookIcon.src"
                    :fit="'contain'"
                  />
                </a>
              </div>
            </div>

            <div class="footer__columns">
              <div
                v-for="(menuGroup, index) in menuGroups"
                :key="`desktop-${index}`"
                :class="[
                  'footer__column',
                  index === menuGroups.length - 1 ? 'footer__column--wide' : '',
                ]"
              >
                <h5 class="menu--header">{{ menuGroup.menuHeader }}</h5>
                <FooterMenuItem
                  v-for="(menuItem, itemIndex) in menuGroup.menuItems"
                  :key="`desktop-${index}-${itemIndex}`"
                  :item="menuItem"
                  @select="handleMenuItemClick"
                />
              </div>
            </div>
          </div>

          <el-divider class="footer__divider" />
          <div class="subtitle2 content-license text-right">
            {{ year }} {{ allRightsReserved }}
          </div>
        </mq-layout>
      </MainLayout>
    </div>
    <el-dialog class="cookies" :visible.sync="addQCCookies" :header="false" width="460px"
      v-if="cookiesModalType == 'QC' && QCCookie == false" :before-close="exitfromSite" :close-on-click-modal="false">
      <el-row>
        <el-col class="pl-10">
          <template v-if="!deniedAccess">
            <label class="title">{{ $t("home.cookiesModal.title") }}</label>
            <div class="description cookie-model">
              <p class="mb-20">{{ $t("home.cookiesModal.p1") }}</p>
              <p>{{ $t("home.cookiesModal.p2") }}</p>
            </div>
            <div class="cookies-button">
              <el-button type="primary" class="button" @click="acceptcookies()">
                {{ $t("home.cookiesModal.accept") }} </el-button>
              <el-button type="primary" class="button" @click="handleModalClose()">
                {{ $t("home.cookiesModal.denied") }} </el-button>
              <el-button type="primary" class="button" @click="exitfromSite()">
                {{ $t("home.cookiesModal.exit") }} </el-button>
            </div>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog class="cookies" :visible.sync="addONCookies" :header="false" width="460px" v-if="cookiesModalType == 'ON' && ONCookie == false"
      :before-close="exitfromSite" :close-on-click-modal="false">
      <el-row>
        <el-col class="pl-10">
          <template v-if="!deniedAccess">
            <label class="title">{{ $t("home.cookiesModalOn.title") }}</label>
            <div class="description cookie-model">
              <p class="mb-20">{{ $t("home.cookiesModalOn.p1") }}</p>
              <p>{{ $t("home.cookiesModalOn.p2") }}</p>
            </div>
            <div class="cookies-button">
              <el-button type="primary" class="button" @click="acceptOncookies()">
                {{ $t("home.cookiesModal.accept") }} </el-button>
              <el-button type="primary" class="button" @click="handleModalCloseON()">
                {{ $t("home.cookiesModal.denied") }} </el-button>
              <el-button type="primary" class="button" @click="exitfromSite()">
                {{ $t("home.cookiesModal.exit") }} </el-button>
            </div>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog class="cookies province-modal" :visible.sync="provinceModal" :header="false" width="460px">
      <el-row>
        <el-col class="pl-10">
          <div class="description cookie-model">
            <p v-if="countryCode == 'QC'">
              {{ $t("home.provinceModalQc") }}
            </p>
            <p v-else>{{ $t("home.provinceModalOn") }}</p>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { get } from "@/utils/lodash";
import MainLayout from "@/components/layout/main-layout.vue";
import layoutUtils from "@/utils/layout-utils";
import imgLogoWhite from "@/assets/images/logo/logo-white.png";
import imgInstagramIcon from "@/assets/images/footer/icons/footer-instagram.png";
import imgFacebookIcon from "@/assets/images/footer/icons/footer-facebook.png";
import FooterMenuItem from "./footer-menu-item.vue";
import Subscription from "@/views/subscription/components/subscription.vue";
import Store from "@/store";
import axios from "axios";
import { createFooterNavigation } from "@/content/footer-navigation";
import { fetchListingPdfUrl } from "@/utils/listing-pdf-utils";
import {
  getCurrentMarket,
  getSocialLinks,
} from "@/utils/market-utils";

export default {
  components: {
    MainLayout,
    FooterMenuItem,
    Subscription,
  },
  data() {
    return {
      images: {
        logo: {
          src: imgLogoWhite,
        },
        instagramIcon: {
          src: imgInstagramIcon,
        },
        facebookIcon: {
          src: imgFacebookIcon,
        },
      },
      addQCCookies: false,
      addONCookies: false,
      cookiesModalType: localStorage.getItem("actualCountryCode") || "QC",
      countryCode: localStorage.getItem("countryCode") || "QC",
      provinceModal: false,
      deniedAccess: false,
      year: new Date().getFullYear(),
      userProvince: "",
      QCCookie: localStorage.getItem("QcCookieSet") || false,
      ONCookie: localStorage.getItem("OnCookieSet") || false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.checkCookiesAndRoute();
    }, 200);
    const value = this.getCookie("user_first_time_token");
    this.setCookieIfNotExists("user_first_time_token");
    if (this.isLoggedIn == false && !value) {
      this.$root.$on("chancountryCode", (code) => {
        if (this.cookiesModalType !== code) {
          this.cookiesModalType = localStorage.getItem("countryCode");
        }

        setTimeout(() => {
          this.provinceModal = false;
        }, 3000);
        setTimeout(() => {
          this.cookiesModalType = code;
        }, 3000);
      });
    }
    if (navigator.geolocation && !value) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          const apiKey = process.env.VUE_APP_MAP_KEY;
          const url = `https://api.openweathermap.org/geo/1.0/reverse?lat=${latitude}&lon=${longitude}&limit=1&appid=${apiKey}`;

          try {
            const response = await axios.get(url);
            const data = response.data[0];
            if (data && data.state) {
              this.userProvince = data.state;

              // `/on` and `/qc` are the HOME route (router: '/:region(on|qc)?'),
              // so this push is only ever a market-flavored home page. It used to
              // fire on whatever page the visitor happened to be on, which threw
              // first-time visitors arriving on a shared deep link (a provider,
              // product or blog URL sent over iMessage/email) straight to the home
              // page the moment they granted location — silently destroying the
              // link they clicked. Only re-flavor home when they are already there.
              if (this.$route.name === "home") {
                const region = data.state.includes("Ontario") ? "/on" : "/qc";
                this.$router.push(region).catch(() => {});
              }
            }
          } catch (error) {
            console.error("Geolocation API error:", error);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  },
  watch: {
    country() {
      this.countryCode = localStorage.getItem("countryCode");
      this.provinceModal = true;
      setTimeout(() => {
        this.provinceModal = false;
      }, 2000);
    },
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    ...mapGetters("user", ["isLoggedIn"]),
    country() {
      return get(this.actionBar, "country");
    },
    market() {
      return getCurrentMarket(this.country);
    },
    socialLinks() {
      return getSocialLinks(this.market);
    },
    addressLine1() {
      return this.$i18n.t("common.footer.address.line1");
    },
    addressLine2() {
      return this.$i18n.t("common.footer.address.line2");
    },
    addressLine3() {
      return this.$i18n.t("common.footer.address.line3");
    },
    allRightsReserved() {
      return this.$i18n.t("common.footer.allRightsReserved");
    },
    isRestaurant() {
      return this.$route && this.$route.fullPath.indexOf("inventory=") > -1;
    },
    isRestaurantDetail() {
      return this.$route && this.$route.fullPath.indexOf("productType=") > -1;
    },
    menuGroups() {
      return createFooterNavigation(this.market, this.$i18n.locale);
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  methods: {
    ...mapActions("user", ["logout"]),
    acceptcookies() {
      localStorage.setItem("QcCookieSet", true);
      this.addQCCookies = false;
      this.deniedAccess = false;
      window.dataLayer.push({
        event: "cookie-consent",
        consentType: "qc",
        consentValue: true,
      });
    },
    acceptOncookies() {
      localStorage.setItem("OnCookieSet", true);
      this.addONCookies = false;
      this.deniedAccess = false;
      window.dataLayer.push({
        event: "cookie-consent",
        consentType: "on",
        consentValue: true,
      });
    },
    async handleMenuItemClick(item) {
      if (item.type === "external") {
        window.open(item.url, "_blank", "noopener");
        return;
      }

      if (item.type === "pdfAction") {
        const pdfWindow = window.open("", "_blank");

        if (pdfWindow) {
          pdfWindow.document.write("<html><head><title>PDF</title></head><body><h4>Loading PDF...</h4></body></html>");
        }

        try {
          const pdfUrl = await fetchListingPdfUrl(item.filters);
          if (pdfWindow && pdfUrl) {
            pdfWindow.location.href = pdfUrl;
          }
        } catch (error) {
          if (pdfWindow) {
            pdfWindow.close();
          }
        }
        return;
      }

      if (item.to) {
        this.$router.push(item.to).catch(() => {});
      }
    },
    handleModalClose() {
      localStorage.setItem("QcCookieSet", true);
      this.addQCCookies = false;
      window.dataLayer.push({
        event: "cookieConsent",
        consentStatus: "false",
      });
    },
    handleModalCloseON() {
      localStorage.setItem("OnCookieSet", true);
      this.addONCookies = false;
      window.dataLayer.push({
        event: "cookieConsent",
        consentStatus: "false",
      });
    },
    exitfromSite() {
      window.location.href = "https://www.google.com";
    },
    checkCookiesAndRoute() {
      const getCountryCode = localStorage.getItem("actualCountryCode");
      if (this.isLoggedIn == true) {
        if ((getCountryCode == "QC" && this.$route.path === "/on") || (getCountryCode == "ON" && this.$route.path === "/qc")) {
          this.handleLogout();
          return;
        }
      }
      if (this.$route.path === "/" || this.$route.path === "/qc") {
        if (this.provinceModal) {
          setTimeout(() => {
            if (!this.provinceModal) {
              this.addQCCookies = true;
              this.addONCookies = false;
            }
          }, 3100);
        } else {
          this.addQCCookies = true;
          this.addONCookies = false;
        }
      }
      if (this.$route.path === "/on") {
        if (this.provinceModal) {
          setTimeout(() => {
            if (!this.provinceModal) {
              this.addONCookies = true;
              this.addQCCookies = false;
            }
          }, 3100);
        } else {
          this.addONCookies = true;
          this.addQCCookies = false;
        }
      }
    },
    handleLogout() {
      Store.dispatch("user/logout");
      Store.dispatch("shoppingCart/emptyShoppingCart");
      Store.dispatch("user/createTempUser");

      this.logout();
      this.$router.push("/login");
    },
    generateUniqueToken() {
      return "xxxxxxxyxxxxxyxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop().split(";").shift();
      }
      return null;
    },
    setCookieIfNotExists(name) {
      let value = this.getCookie(name);
      if (!value) {
        value = this.generateUniqueToken();
        const now = new Date();
        now.setTime(now.getTime() + 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}; expires=${now.toUTCString()}; path=/`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.footer {
  background-color: $color-primary;
  padding-bottom: 16px;
}

.footer--mobile {
  height: auto !important;
}

.footer--color {
  color: $color-on-primary;
}

.footer__mobile-shell,
.footer__desktop-shell {
  padding-top: 34px;
}

.footer__desktop-shell {
  display: grid;
  grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);
  gap: 42px;
  align-items: start;
}

.footer__mobile-columns,
.footer__columns {
  display: grid;
  gap: 24px;
  align-items: start;
}

.footer__columns {
  grid-template-columns:
    minmax(110px, 1fr)
    minmax(110px, 1fr)
    minmax(160px, 1.2fr)
    minmax(110px, 1fr)
    minmax(180px, 1.25fr);
}

.footer__mobile-columns {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 28px;
}

.footer__brand {
  text-align: left;
}

.footer__logo {
  width: 167px;
}

.footer__address {
  margin-top: 12px;
  line-height: 1.5;
}

.footer__social-row {
  display: flex;
  gap: 18px;
  margin-top: 18px;
}

.footer__social-icon {
  height: 28px;
}

.footer__column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  text-align: left;
}

.footer__column--wide {
  min-width: 180px;
}

.menu--header {
  font-weight: $font-weight-bold;
  min-height: 32px;
  margin: 0 0 6px;
  white-space: nowrap;
}

.content-license {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  padding-bottom: 0;
  line-height: 1.4;
}

.footer__divider {
  margin-top: 24px;
  margin-bottom: 12px;
}

.cookie-model {
  word-break: normal !important;
}

.cookies-button {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

@media screen and (max-width: $media-md) {
  .footer__mobile-shell {
    padding-top: 28px;
    padding-bottom: 8px;
  }

  .footer__mobile-columns {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .menu--header {
    min-height: auto;
    white-space: normal;
  }
}
</style>
